export enum PortingType {
  UNSET_PORTING_TYPE = 'UNSET_PORTING_TYPE',
  PORT_IN = 'PORT_IN',
  PORT_OUT = 'PORT_OUT',
  REVERSE_PORT_IN = 'REVERSE_PORT_IN',
  REVERSE_PORT_OUT = 'REVERSE_PORT_OUT',
}
